"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLabels = exports.labelsContextDefaultValue = exports.labelsContext = exports.LabelsProvider = void 0;
var _react = require("react");
var _api = require("../../api");
var _net = require("../../models/graphql-types/net");
var _jsxRuntime = require("react/jsx-runtime");
const labelsContextDefaultValue = exports.labelsContextDefaultValue = {
  aboutLabel: '',
  joinLabel: '',
  joinUrl: '',
  loading: true
};
const labelsContext = exports.labelsContext = /*#__PURE__*/(0, _react.createContext)(labelsContextDefaultValue);
const {
  Provider
} = labelsContext;
const findLabel = (item, fallback, collection) => collection?.find(({
  type
}) => type === item)?.title ?? fallback;
const findUrl = (item, fallback, collection) => collection?.find(({
  type
}) => type === item)?.url ?? fallback;
const LabelsProvider = ({
  children
}) => {
  const {
    data: items,
    loading
  } = (0, _api.useGetNavigationType)({
    type: _net.NavigationType.TopNavigation
  });
  const value = (0, _react.useMemo)(() => ({
    aboutLabel: findLabel(_net.NavigationType.AboutTiles, labelsContextDefaultValue.aboutLabel, items),
    joinLabel: findLabel(_net.NavigationType.JoinTiles, labelsContextDefaultValue.joinLabel, items),
    joinUrl: findUrl(_net.NavigationType.JoinTiles, labelsContextDefaultValue.joinUrl, items),
    loading
  }), [items, loading]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: value,
    children: children
  });
};
exports.LabelsProvider = LabelsProvider;
const useLabels = () => (0, _react.useContext)(labelsContext);
exports.useLabels = useLabels;